import Vue from 'vue';
import App from './App.vue';
//import ElementUI from 'element-ui';
//import 'element-ui/lib/theme-chalk/index.css'
import NProgress from 'nprogress'; // Progress 进度条
import 'nprogress/nprogress.css'; // Progress 进度条 样式
import './res/font-awesome/css/font-awesome.min.css'; //font-awesome样式
import common from './other/tool.js';
import router from './menu/index';
import store from './other/store/';
import VueWechatTitle from 'vue-wechat-title'
import animated from './res/css/animate.css' // npm install animate.css --save安装，在引入
import 'lib-flexible'
    
import Vant from 'vant';
import 'vant/lib/index.css'; 
Vue.use(Vant);
// import VConsole from 'vconsole';
// const vConsole = new VConsole();  

Vue.use(VueWechatTitle);
Vue.use(animated);
//Vue.use(ElementUI, {size: 'small'})
//Vue.use(require('moment'));

Vue.config.ignoredElements = ['wx-open-launch-weapp'];

Object.keys(common).forEach((key) => {
    Vue.prototype[key] = common[key];
});                 
Vue.config.productionTip = process.env.NODE_ENV !== 'production';
Vue.config.devtools = process.env.NODE_ENV !== 'production';
    

//router.beforeEach((to, from, next) => {
//    NProgress.start();
// 判断是否有token
//if (getCookie("token")) {
//    //如果即将要进入的目标为登录页
//    if (to.path == '/login') {
//        //管道中的下一个钩子进入的目标指向首页
//        next({path: '/home'});
//    } else {
//        //debugger
//        //获取权限列表，根据权限显示主菜单
//        if (store.getters.roles.length == 0) {
//            common.$http.request(
//                "/ComCtrl/getPermitById", {}
//            ).do(resp => {
//                //common.encode('authority', resp.cont.list);
//                store.dispatch('LoginIn', resp.cont.list).then(() => {
//                    //匹配生成可访问的路由
//                    store.dispatch('GenerateRoutes', resp.cont.list).then(() => {
//                        router.addRoutes(store.getters.addRouters);
//                        if (store.getters.roles.length == 0) {
//                            next();
//                        } else {
//                            next({...to})
//                        }
//                    })
//                })
//            });
//        } else {
//            next();
//        }
//    }
//} else {
//    let whiteList = ['/login'];// 不重定向白名单
//    if (whiteList.indexOf(to.path) !== -1) { // 在免登录白名单，直接进入
//        next();
//    } else {
//        next('/login'); // 否则全部重定向到登录页
//        NProgress.done(); // 在hash模式下 改变手动改变hash 重定向回来 不会触发afterEach 暂时hack方案 ps：history模式下无问题，可删除该行！
//    }
//}
//});

router.afterEach(() => {
    NProgress.done(); // 结束Progress
});

//验证页面权限
//Vue.directive('permit', {
//    bind: function (el, binding, vnode) {
//        //debugger
//        //console.log(store.getters.roles);
//        //console.log(binding.value);
//        if (store.getters.roles.indexOf(binding.value) == -1) {
//            //console.log(binding.value)
//            //console.log("TRUE");
//            el.parentNode.removeChild(el)
//            //el.style.display = 'none';
//        }
//    }
//});


new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app');



// WEBPACK FOOTER //
// ./src/App.js